import { Stack } from '@chakra-ui/react';

import { BlogSectionHeading } from '../BlogSectionHeading';
import type { ContentItem } from './ContentsContent';
import { ContentsContent } from './ContentsContent';

interface DesktopContentsProps {
  contents: ContentItem[];
  hasDisclaimer?: boolean;
  hasReferences?: boolean;
  hasTranscript?: boolean;
  hasSpeakers?: boolean;
  hasKeyTakeaways?: boolean;
}

export function DesktopContents(props: DesktopContentsProps) {
  return (
    <Stack spacing="2xs">
      <BlogSectionHeading>Table of contents</BlogSectionHeading>
      <ContentsContent {...props} />
    </Stack>
  );
}
